import { jsx } from "react/jsx-runtime";
import { isInSameWeek, isInSameMonth } from "../../model";
import { PickersDayWeekTypeStyled } from "./index";
const PickersDayWeekDate = (props) => {
  const { viewType, day, selectedDay, hoveredDay, ...other } = props;
  return /* @__PURE__ */ jsx(
    PickersDayWeekTypeStyled,
    {
      $viewType: viewType,
      $selectedDay: selectedDay,
      ...other,
      day,
      disableMargin: true,
      selected: false,
      isSelected: viewType === "week-date" ? isInSameWeek(day, selectedDay) : isInSameMonth(day, selectedDay),
      isHovered: viewType === "week-date" ? isInSameWeek(day, hoveredDay) : isInSameMonth(day, hoveredDay)
    }
  );
};
export {
  PickersDayWeekDate
};
